export const translate = (translations, key) => {
	if (typeof translations === 'object' && key in translations) {
		return translations[key];
	}
	return key;
};
